// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + "-" + {"27":"174d39fc","348":"e3476644","546":"21519258","558":"2a0b3b49","571":"9cf9c0f8"}[chunkId] + ".chunk.js";
};